import React from 'react';
import './checkbox.css';

const Checkbox = ({ active, caption, handler }) => {
    return (
        <div className={ `cb ${ active ? 'cb--active' : '' }` }
            onClick={ handler }
        >
            <i className="cb__ico"/>
            <div className="cb__caption">{ caption }</div>
        </div>
    );
};

export default Checkbox;